export default "__VITE_ASSET__CND7XT79__"